module.exports = __webpack_public_path__ + "static/media/close.d293f158.svg";